export default __webpack_public_path__ + "static/media/pic4.99f3c0de.jpg";